import { ReactElement, useState } from 'react';
import { GatewayDetails, ActionData } from '../../constants/telosair-interfaces';
import GatewayRow from './GatewayRow';

type GatewaysTableComponentProps = {
  gateways: GatewayDetails[];
  handleGatewayAction: (data: ActionData<GatewayDetails>) => void;
};

/**
 * A Gateways Table Component.
 * @param props - Gateways Table Component Props.
 * @returns - A React Component.
 */
export default function GatewaysTable(props: GatewaysTableComponentProps): ReactElement {
  const { gateways, handleGatewayAction } = props;
  const [sortAscending, setSortAscending] = useState(true);

  // Sort the gateways based on the "gatewayName" property
  const sortedGateways = [...gateways].sort((a, b) =>
    sortAscending
      ? a.gatewayName.localeCompare(b.gatewayName)
      : b.gatewayName.localeCompare(a.gatewayName)
  );
  return (
    <div className="rounded shadow-md bg-white dark:bg-container-700 flex text-gray-400 dark:text-gray-400 text-sm font-medium border-b border-b-gray-300 dark:border-b-gray-900">
      <table className="w-full">
        <tr className="w-full text-gray-400 text-xs font-medium">
          <th className="px-6 py-3 flex items-center">
            Gateway Name
            <button
              type="button"
              className="material-icons-outlined text-sm  pl-1 cursor-pointer"
              onClick={() => setSortAscending((prevSort) => !prevSort)}
            >
              {sortAscending ? 'arrow_downward' : 'arrow_upward'}
            </button>
          </th>
          <th className="text-center">Gateway ID</th>
          <th className="text-center">Connection Status</th>
          <th className="text-center">Gateway IP</th>
          <th className="text-center">Software Version</th>
          <th className="text-center">Data Rate</th>
          <th className="text-center">Action</th>
        </tr>
        {sortedGateways.map((gateway) => (
          <GatewayRow
            key={gateway.id}
            gateway={gateway}
            handleGatewayAction={handleGatewayAction}
          />
        ))}
      </table>
    </div>
  );
}
